export default __webpack_public_path__ + "static/media/trainer_4.60dd3499.PNG";